import React, { useEffect, useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import rData from "../../files/RiasecData.json";
import { Doughnut } from "react-chartjs-2";
import $ from 'jquery';

const ReportSummary = props => {
    let rId = props.roomId ?? null
    const customTitle = props.customTitle ?? null
    const customSubtitle = props.customSubtitle ?? null
    const customBorder = props.customBorder ?? null
    const showFor = props.showFor ?? null
    const mobileShowHide = props.mobileShowHide ?? true
    const user = AuthService.getCurrentUser();
    const maxTopScore = 5;
    const maxTopRightScore = maxTopScore + 15; // collect 15 array

    // set State
    const [graphData, setGraphData] = useState(null);
    const [top5Score, setTop5Score] = useState(null);
    const [topRightScore, setTopRightScore] = useState(null);
    const [topOtherScore, setTopOtherScore] = useState(null);
    const [bgScore, setBgScore] = useState(null);
    const [score, setScore] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [modalOtherShow, setModalOtherShow] = useState(false);
    const [modalRiasec, setModalRiasec] = useState('');
    const [modalSource, setModalSource] = useState('');

    const filterYear = props.filterYear ?? null
    const filterTerm = props.filterTerm ?? null


    useEffect(() => {
        try {
            setGraphData(null);
            setTop5Score(null);
            setTopRightScore(null);
            setTopOtherScore(null);
            setBgScore(null);
            setScore(null);
            setModalShow(false);
            setModalOtherShow(false);
            setModalRiasec('');
            setModalSource('');       
            UserService.getRoomList({ id: user.id, domain: user.domain.name, year:filterYear, term:filterTerm }).then(
                (res) => {                    
                    if (res && res.data.data !== [] && (!rId || rId === 0 || rId === '0' || rId === null)) {
                        if (filterYear && filterTerm) {
                            const data = res.data.data
                            const filterRId = data.filter(function (val) { return parseInt(val.term) === parseInt(filterTerm) && parseInt(val.year) === parseInt(filterYear) });
                            return filterRId[0]?.id
                        } else if (res.data.data && res.data.data[0] && res.data.data[0].id) {
                            return res.data.data[0].id
                        }
                    }
                    return rId
                }).then((roomId) => {
                    UserService.getRiasecReport(roomId).then((response) => {
                   
                        if (response?.data?.data) {
                            let data = null
                            if (showFor && showFor === 'domain') {
                                data = response.data.data.byDomain
                            } else if (showFor && showFor === 'room') {
                                data = response.data.data.byRoom
                            }
                            const arrTotal = data.total
                         
                            // remove empty index
                            const eIndex = arrTotal.findIndex(p => p.id === '');
                            arrTotal.splice(eIndex, 1);

                            //sort by count
                            arrTotal.sort(function (a, b) { return b.count - a.count });
                            const t5 = arrTotal.slice(0, maxTopScore);
                            const tR = arrTotal.slice(maxTopScore, maxTopRightScore);
                            const tE = arrTotal.slice(maxTopRightScore);
                            setTop5Score(t5)
                            setTopRightScore(tR)
                            setTopOtherScore(tE)
                            setScore({ done: numberWithCommas(data.totalDone), all: numberWithCommas(data.totalStudent) })
                            let labels = []
                            let t5c = []
                            let t5cBG = []
                            const t5BG = [
                                'rgba(86, 124, 186)',
                                'rgb(171, 161, 221)',
                                'rgb(177, 227, 255)',
                                'rgb(199, 129, 191)',
                                'rgb(82, 216, 201)'
                            ]
                            t5.forEach(function (value, i) {
                                labels.push(value.id)
                                t5c.push(value.count)
                                t5cBG.push(t5BG[i])
                            });
                            setGraphData({
                                labels,
                                datasets: [{
                                    label: 'Riasec Stat',
                                    data: t5c,
                                    backgroundColor: t5cBG
                                }]
                            })
                            setBgScore(t5BG)
                        }
                    });
                });
        } catch (error) {

        }
    }, [filterYear, filterTerm, rId]);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function showHideSectionrRiasec(section) {
        console.log(section);
        var targetID = $('#' + section);
        var tragetClass = $('.' + section);
        if (targetID.hasClass('showhide-red')) {
            targetID.removeClass('showhide-red');
            targetID.addClass('showhide-green');
            tragetClass.hide();
        } else {
            targetID.removeClass('showhide-green');
            targetID.addClass('showhide-red');
            tragetClass.show();
        }

    }
    return (
        <div>
            <Row className='report-riasec mb-3 mb-lg-4 pt-3'>
                <Col xs={12} className="text-center font-sarabun">
                    {
                        (showFor === 'domain') ? (
                            <div>
                                <h2 className="font-sarabun-bold mb-0 pt-4 pt-lg-0">
                                    {(customTitle) ? customTitle : "แบบประเมิน RIASEC"}
                                </h2>
                                <button className={`${mobileShowHide ? '' : 'd-none d-lg-inline'} btn-showhide border-gray showhide-red`} id="showHideRIASEC" onClick={() => showHideSectionrRiasec('showHideRIASEC')}> </button>
                            </div>
                        ) : (
                            <div>
                                <h2 className="font-sarabun-bold mb-3 pt-4 pt-lg-0">
                                    ผลประเมินแบบทดสอบความสนใจทางอาชีพในห้องเรียน
                                </h2>
                            </div>
                        )}

                </Col>
                <Col xs={12} className="showHideRIASEC pb-lg-3">
                    {
                        (showFor === 'domain') ? (
                            <div>
                                {
                                    (score && customSubtitle) ?
                                        <h3 className="text-center mt-2 mb-4 grey-dark-text">{(customSubtitle) ? customSubtitle : 'ทำประเมินแล้ว'} ({score.done}/{score.all} คน)</h3>
                                        : null
                                }
                                {
                                    (score && !customSubtitle) ?
                                        <p className="text-center"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> ทำประเมินแล้ว ({score.done}/{score.all} คน)</p>
                                        : null
                                }
                            </div>
                        ) : (
                            <div>
                                {
                                    (score && customSubtitle) ?
                                        <h3 className="text-center mt-2 mb-4 grey-dark-text">{(customSubtitle) ? customSubtitle : 'ทำประเมินแล้ว'} ({score.done}/{score.all} คน)</h3>
                                        : null
                                }
                            </div>
                        )}
                    {
                        (score && score.done > 0) ? (
                            <Row className={`${customBorder ? 'custom-curve-border-desktop' : ''}`}>
                                <Col xs={12} lg={5}>
                                    <Row>
                                        <Col xs={12} className='text-center text-lg-left font-sarabun-bold mb-3'>
                                            <span className='header-riasec'>5 อันดับแรกจาก RIASEC Score </span>
                                            <br className="d-lg-none" />
                                            <a href='/riasec/meaning' className='click-pointer what-is' target='_blank'>RIASEC คืออะไร?&#62;</a>
                                        </Col>
                                        <Col xs={6} md={7}>
                                            {
                                                (graphData) ? (
                                                    <Doughnut
                                                        data={graphData}
                                                        options={{
                                                            plugins: {
                                                                legend: {
                                                                    display: false,
                                                                    position: 'bottom'
                                                                }
                                                            },
                                                            responsive: true,
                                                            maintainAspectRatio: true
                                                        }}
                                                    />
                                                ) : (
                                                    <div></div>
                                                )
                                            }
                                        </Col>
                                        <Col xs={6} md={5}>
                                            <div className='top-5 font-sarabun-bold py-2'>
                                                {
                                                    (top5Score && bgScore && top5Score.length > 0) ? (
                                                        top5Score.map((item, index) => (
                                                            (item && item.id) ? (
                                                                <p key={index} className='pl-3 top5-list my-2 d-flex'>
                                                                    <div className="div-dot" style={{ "backgroundColor": bgScore[index] }} />
                                                                    <div className="d-grid pl-2 text-left w-100">
                                                                        <span className=''>{item.id}: </span>
                                                                        <span className=''>{item.count}</span>
                                                                        <img src='/images/riasec/report-icon.png' className='icon text-right click-pointer mt-1' alt='' onClick={() => { handlePopup(item.id); }} />
                                                                    </div>
                                                                </p>
                                                            ) : (<span className='d-none' />)
                                                        ))
                                                    ) : (
                                                        <span />
                                                    )
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={7}>
                                    <Row>
                                        <Col xs={12}>
                                            <h4 className='font-sarabun-bold top-right-score-header'>RIASEC ในอันดับอื่นๆ</h4>
                                        </Col>
                                        {
                                            (topRightScore && topRightScore.length > 0) ? (
                                                topRightScore.map((item, index) => (
                                                    (item && item.id) ? (
                                                        <Col xs={4} lg={3} key={index}>
                                                            <div className='block-info p-2 pl-3 mt-2'>
                                                                <span className='font-sarabun-bold'>{item.id} : </span>
                                                                <span className='font-sarabun'>{item.count}</span>
                                                                <img src='/images/riasec/report-icon.png' className='icon text-right click-pointer' alt='' onClick={() => { handlePopup(item.id); }} />
                                                            </div>
                                                        </Col>
                                                    ) : (<span className='d-none' />)
                                                ))
                                            ) : (
                                                <span />
                                            )
                                        }

                                        {
                                            (topOtherScore && topOtherScore.length > 0) ? (
                                                <Col xs={4} lg={3}>
                                                    <div className='block-info p-2 pl-3 mt-2'>
                                                        <span className='font-sarabun-bold'>อื่นๆ</span>
                                                        <img src='/images/riasec/report-icon.png' className='icon text-right click-pointer' alt='' onClick={() => { handleOtherPopup(); }} />
                                                    </div>
                                                </Col>

                                            ) : (
                                                <span />
                                            )
                                        }

                                        <Col xs={12} className='mt-3'>
                                            <p className='remark'><span className='font-sarabun-bold'>หมายเหตุ:</span> <span className='font-sarabun'>เด็กบางคนมีความถนัดมากกว่า 1 ด้าน อาจทำให้จำนวนรวมในส่วนนี้เกินจำนวนนักเรียน</span></p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ) : (<div className='text-center font-sarabun-bold my-3'>ยังไม่มีผลประเมิน</div>)}
                </Col>
            </Row>
            <RiasecDescibe
                show={modalShow}
                onHide={() => { setModalShow(false); }}
            />
            <RiasecOther
                show={modalOtherShow}
                onHide={() => { setModalOtherShow(false); setModalSource(''); }}
            />
        </div>
    )

    function handlePopup(riasec, other = false) {
        if (riasec) {
            setModalSource('');
            const i = rData.findIndex(x => x.riasec === riasec);
            setModalRiasec(rData[i])
            setModalShow(true);
            if (other) {
                setModalSource('other')
            }
        }
    }

    function handleOtherPopup() {
        setModalOtherShow(true);
    }

    function handleBackToOtherPopup() {
        setModalShow(false);
        setModalOtherShow(true);
        setModalSource('');
    }

    function RiasecOther(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="riasec-summary-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row className="pt-0 pb-3 px-md-4 other-riasec font-sarabun-bold">
                        <Col xs={12}>
                            <p className='header'>อื่นๆ</p>
                        </Col>
                        {
                            (topOtherScore && topOtherScore.length > 0) ? (
                                <Col xs={4} className=''>
                                    {topOtherScore.slice(0, 6).map((item, index) => (
                                        <p className='mb-0 my-lg-2'>
                                            {item.id} : {item.count} <img src='/images/riasec/report-icon.png' className='icon ml-2 click-pointer mb-1' alt='' onClick={() => { setModalOtherShow(false); handlePopup(item.id, 1); }} />
                                        </p>
                                    ))}
                                </Col>
                            ) : (<div />)
                        }
                        {
                            (topOtherScore && topOtherScore.length > 0) ? (
                                <Col xs={4} className=''>
                                    {
                                        topOtherScore.slice(6, 12).map((item, index) => (
                                            <p>
                                                {item.id} : {item.count} <img src='/images/riasec/report-icon.png' className='icon ml-2 click-pointer mb-1' alt='' onClick={() => { setModalOtherShow(false); handlePopup(item.id, 1); }} />
                                            </p>
                                        ))}
                                </Col>
                            ) : (<div />)
                        }
                        {
                            (topOtherScore && topOtherScore.length > 0) ? (
                                <Col xs={4} className=''>
                                    {topOtherScore.slice(12).map((item, index) => (
                                        <p>
                                            {item.id} : {item.count} <img src='/images/riasec/report-icon.png' className='icon ml-2 click-pointer mb-1' alt='' onClick={() => { setModalOtherShow(false); handlePopup(item.id, 1); }} />
                                        </p>
                                    ))}
                                </Col>
                            ) : (<div />)
                        }
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function RiasecDescibe(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="riasec-summary-modal"
                centered
            >
                <Modal.Header closeButton>
                    {
                        (modalSource && modalSource === 'other') ? (<span className='click-pointer backArrow ml-3' onClick={() => { handleBackToOtherPopup(); }}>&#60;</span>) : (<span />)
                    }
                </Modal.Header>
                <Modal.Body>
                    <Row className="pt-0 pb-3 px-md-4">
                        <Col xs={12} className='position-relative text-center'>
                            <img src='/images/riasec/result-circle.png' className='riasec-circle' width={'100%'} alt='circle' />
                            <div className={`result-circle-frame position-absolute d-flex`}>
                                <div className='m-auto result-circle-text'>
                                    {modalRiasec.riasec}
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} className='describe font-sarabun'>
                            {modalRiasec.personality}
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ReportSummary